// ProfileInfoUserHashtags.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { SanitizedLink as Link } from '../component/SanitizedLink.jsx';
import { textColor, color } from '../style/variables.js';
import media from '../style/media.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { ButtonId } from '../resource/trackingConstants.js';

const defaultArray = [];
const defaultFunction = () => null;

export const ProfileInfoUserHashtags = ({
  hashtags = defaultArray,
  mixpanelModalId = '',
  hashtagFeedUser = '',
  onClick = defaultFunction,
}) => {
  const { t } = useTranslation();
  return (
    <StyledProfileInfoUserHashtags>
      {hashtags.map((hashtag, index) => {
        const feedName = hashtagFeedUser.replace('{HASHTAG}', hashtag);
        return (
          <UserHashtagLink
            key={index}
            onClick={event => onClick(event, hashtag)}
            to={`/user-feed-grid/${feedName}`}
            data-element_id={ButtonId.Hashtag.ButtonUserHashtag}
            data-tracking_payload={{
              hashtag,
              modalId: mixpanelModalId,
            }}
          >
            {t(`user_hashtag_${hashtag}`, { ns: TranslationNamespace.PROFILE })}
          </UserHashtagLink>
        );
      })}
    </StyledProfileInfoUserHashtags>
  );
};

ProfileInfoUserHashtags.propTypes = {
  mixpanelModalId: PropTypes.string,
  hashtagFeedUser: PropTypes.string,
  hashtags: PropTypes.array,
  onClick: PropTypes.func,
};

const StyledProfileInfoUserHashtags = styled.div``;

const UserHashtagLink = styled(Link)`
  margin-right: 8px;
  margin-bottom: 4px;
  display: inline-block;
  border-radius: 40px;
  padding: 2px 8px;
  background-color: ${color.neutral['85_alpha_20']};
  color: ${textColor.primary};
  line-height: 150%; /* 24px */
  letter-spacing: 0.024px;
  font-size: 16px;
  ${media.tablet`
  font-size: 12px;
`};
`;

export default ProfileInfoUserHashtags;
